import { Col, DatePicker, Form, Row } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import { useDateFormat } from "../../../../../hooks/use-date-format.ts"
import { dateAutoFill } from "../../../../../utils/form/date-auto-fill.tsx"
import { type TemplateDocumentFormData } from "../../../types/template-document-form-data.tsx"
import { DurationFormItem } from "../DurationFormItem.tsx"
import { TextArea } from "../../../../../components/Input/TextArea.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"
interface ProjectOverviewBlockProps {
  form: FormInstance<TemplateDocumentFormData>
}

export function ProjectOverviewBlock({ form }: ProjectOverviewBlockProps) {
  const { getDateValueProps, createDateRangeRules } = useDateFormat()

  // const key: keyof TemplateDocumentFormData = "project"

  // const startDate = Form.useWatch([key, "start_date"], form)
  // const completionDate = Form.useWatch([key, "completion_date"], form)

  // todo for future
  // useEffect(() => {
  //   if (startDate && completionDate) {
  //     const daysDiff = dayjs(completionDate).diff(dayjs(startDate), "day") + 1
  //
  //     let duration: number
  //     let period: "days" | "weeks" | "months"
  //
  //     if (daysDiff >= 28) {
  //       // Якщо близько до місяців (28+ днів)
  //       duration = Math.round(daysDiff / 30)
  //       period = "months"
  //     } else if (daysDiff >= 7) {
  //       // Якщо близько до тижнів (7+ днів)
  //       duration = Math.round(daysDiff / 7)
  //       period = "weeks"
  //     } else {
  //       duration = daysDiff
  //       period = "days"
  //     }
  //
  //     duration = Math.max(1, duration)
  //
  //     form.setFieldsValue({
  //       [key]: {
  //         duration: duration?.toString(),
  //         duration_type: period
  //       }
  //     })
  //   }
  // }, [startDate, completionDate, form, key])

  return (
    <>
      <Row gutter={[12, 0]}>
        <Col span={12}>
          <Form.Item<TemplateDocumentFormData>
            name={["project_type"]}
            label="Project Type"
            rules={[
              {
                required: false,
                whitespace: true,
                message: "Please input project type"
              }
            ]}
          >
            <TextArea disabled placeholder="Enter project type" autoSize />
          </Form.Item>
        </Col>
        <Col span={12}>
          <DurationFormItem<TemplateDocumentFormData>
            durationName={["duration"]}
            durationDependencies={[["start_date"], ["completion_date"]]}
            typeName={["duration_type"]}
            formItemProps={{ label: "Duration" }}
          />
        </Col>
        <Col span={8}>
          <Form.Item<TemplateDocumentFormData>
            name={["start_date"]}
            label="Start Date"
            dependencies={[["completion_date"]]}
            getValueProps={getDateValueProps}
            rules={createDateRangeRules<TemplateDocumentFormData>(
              "completion_date",
              "start"
            )}
          >
            <DatePicker
              className="w-full"
              onChange={dateAutoFill<TemplateDocumentFormData>({
                form,
                endDatePath: ["completion_date"]
              })}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<TemplateDocumentFormData>
            name={["completion_date"]}
            label="Completion Date"
            dependencies={[["start_date"]]}
            getValueProps={getDateValueProps}
            // rules={[
            //   ({ getFieldValue }) => ({
            //     validator(_, value) {
            //       const startDate = getFieldValue([ "start_date"])
            //       if (
            //         value &&
            //         startDate &&
            //         dayjs(value).isBefore(dayjs(startDate))
            //       ) {
            //         return Promise.reject(
            //           new Error("Completion date cannot be before start date")
            //         )
            //       }
            //       return Promise.resolve()
            //     }
            //   })
            // ]}
          >
            <DatePicker className="w-full" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<TemplateDocumentFormData>
            name={["prepared_by"]}
            label="Prepared By"
          >
            <TextInput disabled placeholder="Enter prepared by" />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item<TemplateDocumentFormData>
            name={["summary"]}
            label="Summary"
          >
            <TextArea rows={3} placeholder="Enter summary..." />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
